export default __webpack_public_path__ + "static/banner_nft-95b85d26d97eb6f10f252ed2952ed084.webp";